import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { BASE_FONT_FAMILY, HIGHLIGHT_COLOR } = constants;

let styles = {
  base: {
    fontSize: '1em',
    fontFamily: BASE_FONT_FAMILY,
    height: 40,
    width: '100%',
    border: `1px solid ${HIGHLIGHT_COLOR}`,
    borderRadius: 4,
    boxSizing: 'border-box',
    padding: 12
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/input/Input.styles.js